$(document).ready(function(){

  iniWishlist();

});

function iniWishlist(){
  $(".wishlist button.add-wishlist").click(function(e){
    e.preventDefault();
    var d = $(this).parent();
    $.ajax({
      type:"POST",
      url:"/contact",
      data:d.serialize(),
      beforeSend:function(){

      },
      success:function(n){
        d.html('<a class="add-wishlist" href="/pages/wish-list"><i class="fa fa-heart"></i></a>');
        if (!!$.prototype.fancybox)
          $.fancybox.open([{
            type: 'inline',
            autoScale: true,
            minHeight: 30,
            content: '<p class="fancybox-error">' + 'Added to your wishlist.' + '</p>'
          }], {
            padding: 0
          });
        else
          alert('added to wishlist');
      },
      error:function(){

      }
    })
  });
}